// RegistrationGH.jsx
import React, { useState, useEffect, useCallback } from "react";
import apiClient from "../api/axiosClient";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import SidebarGuideline from "./SidebarGuideline";
import "../styles/Form.css";
import TextField from "@mui/material/TextField";
import {downloadFile} from '../common'

const FIELD_MAX_LENGTH = 100;
const COMMENT_MAX_LENGTH = 100;
const COMPANY_PROFILE_MAX_LENGTH = 300;
const PHONE_MAX_LENGTH = 10;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;

const RegistrationGH = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [userInfo, setUserInfo] = useState();
  const [formId, setFormId] = useState("Unknown");
  const [PkId, setPkId] = useState(0);

  const [formData, setFormData] = useState({
    Organisationname: "",
    category: "Green Hydrogen Company of the Year",
    mailingAddress: "",
    authorityName: "",
    authorityTitle: "",
    authorityPhone: "",
    authorityLandline: "",
    authorityEmail: "",
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    companyProfile: "",
    approvingAuthoritySignature: "",
    declaration: false,
    comment: "",
    installedCapacity2024: "",
    production2024: "",
    carbonEmission2024: "",
    purity2024: "",
    costOfProduction2024: "",
    patentsFiled2024: "",
    patentsGrantedNational2024: "",
    patentsCommercialized2024: "",
    investmentActivities2024: "",
    investmentActivities2023: "",
    investmentElectrolyser2024: "",
    investmentElectrolyser2023: "",
    patentsGrantedInternational2024: "",
    upcomingProjects2024: "",
    upcomingProjects2023: "",
    attachments1: { description: "", file: null },
    attachments2: { description: "", file: null },
    attachments3: { description: "", file: null },
    attachments4: { description: "", file: null },
    projectName1: "",
    location1: "",
    capacity1: "",
    projectCompletionYear1: "",
    projectCurrentStatus1: "",
    projectName2: "",
    location2: "",
    capacity2: "",
    projectCompletionYear2: "",
    projectCurrentStatus2: "",
    projectName3: "",
    location3: "",
    capacity3: "",
    projectCompletionYear3: "",
    projectCurrentStatus3: "",
    projectName4: "",
    location4: "",
    capacity4: "",
    projectCompletionYear4: "",
    projectCurrentStatus4: "",
    projectName5: "",
    location5: "",
    capacity5: "",
    projectCompletionYear5: "",
    projectCurrentStatus5: "",
  });

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("user_info");
      if (stored) {
        const user = JSON.parse(stored);
        setUserInfo(JSON.parse(stored));
        setFormId(`green_hydrogen_${user.id}`);

        setFormData((prev) => ({
          ...prev,
          userid: user.id || "",
          firstname: user.first_name || "",
          lastname: user.last_name || "",
          company_name: user.organisation_name || "",
          Organisationname: user.organisation_name || "",
          applicant_name: user.applicant_name || "",
          applicant_phone: user.applicant_phone || "",
          applicant_email: user.email || "",
        }));
      }
    } catch (err) {
      console.warn("Failed to parse user_info from localStorage:", err);
    }
  }, []);

  // This use Effect Prefill user Data using api;
  useEffect(() => {
    if (userInfo && formId) {
      prefillFormData();
    } else {
      console.warn(
        `userInfo OR formId is invalid; Kindly check the method. and data`
      );
    }
  }, [userInfo, formId]);

  const isSubmited = () => formData.form_mode === "submit";

  // async function prefillFormData() {
  //   if (!userInfo || !formId) {
  //     console.log("prefillFormData: missing userInfo or formId");
  //     return;
  //   }

  //   const url = `/green-hydrogen/?user_id=${encodeURIComponent(userInfo.id)}&form_id=${encodeURIComponent(formId)}`;
  //   try {
  //     const res = await apiClient.get(url);

  //     // Expecting a single-item array for this user & form_id
  //     if (!Array.isArray(res.data) || res.data.length !== 1) {
  //       console.log("No single prefill item found:", res.data);
  //       return;
  //     }

  //     const _ResData = res.data[0];

  //     // Primary PK
  //     const pk = _ResData.id ?? _ResData.pk ?? _ResData.pk_id ?? 0;
  //     setPkId(pk);

  //     // helpers
  //     const safeStr = (v) => (v === null || v === undefined ? "" : String(v));
  //     const get = (...keys) => {
  //       for (const k of keys) {
  //         if (_ResData[k] !== undefined && _ResData[k] !== null) return _ResData[k];
  //       }
  //       return undefined;
  //     };

  //     // Build newFields mapping all frontend state keys you use in handleSubmit
  //     const newFields = {
  //       // identity / user
  //       userid: get("userid", "user_id", "user", "created_by") ?? (userInfo?.id ?? ""),
  //       firstname: get("firstname", "first_name") ?? (userInfo?.first_name ?? ""),
  //       lastname: get("lastname", "last_name") ?? (userInfo?.last_name ?? ""),

  //       // organisation / company
  //       Organisationname: get("organisation_name", "organisationName", "company_name", "companyName") ?? (userInfo?.organisation_name ?? ""),
  //       companyName: get("company_name", "companyName") ?? get("company_name") ?? "",
  //       company_name: get("company_name", "companyName") ?? "",

  //       // meta
  //       category: get("category") ?? "",
  //       form_id: get("form_id") ?? formId,
  //       form_mode: get("form_mode", "formMode") ?? "draft",
  //       comment: get("comment", "notes", "remarks") ?? "",
  //       created_at: get("created_at", "createdAt") ?? null,
  //       updated_at: get("updated_at", "updatedAt") ?? null,

  //       // address / contact
  //       mailingAddress: get("mailing_address", "mailingAddress", "address") ?? "",
  //       contact_name: get("contact_name", "contactName") ?? "",
  //       contact_phone: safeStr(get("contact_phone", "contactPhone") ?? ""),
  //       contact_email: get("contact_email", "contactEmail") ?? "",

  //       // applicant (if present)
  //       applicant_name: get("applicant_name", "applicantName", "applicant") ?? "",
  //       applicant_phone: safeStr(get("applicant_phone", "applicantPhone") ?? ""),
  //       applicant_email: get("applicant_email", "applicantEmail") ?? "",

  //       // authority / approving authority
  //       authorityName: get("authority_name", "authorityName", "approving_authority_name") ?? "",
  //       authorityTitle: get("authority_title", "authorityTitle", "approving_authority_title") ?? "",
  //       authorityPhone: safeStr(get("authority_phone", "authorityPhone", "approving_authority_phone") ?? ""),
  //       authorityLandline: safeStr(get("authority_landline", "authorityLandline") ?? ""),
  //       authorityEmail: get("authority_email", "authorityEmail") ?? "",

  //       // narrative fields
  //       companyProfile: get("company_profile", "companyProfile", "company_description") ?? "",
  //       awardJustification: get("award_justification", "awardJustification") ?? "",
  //       declaration: (get("declaration") === true || get("declaration") === "true") ?? false,
  //     };

  //     // Quantitative fields mapping (2024/2023). Covers variants like base_2024, base2024, camelCase
  //     const quantBases = {
  //       installedCapacity: ["installed_capacity", "installedCapacity"],
  //       production: ["production"],
  //       carbonEmission: ["carbon_emission", "carbonEmission"],
  //       purity: ["purity"],
  //       costOfProduction: ["cost_of_production", "costOfProduction"],
  //       patentsFiled: ["patents_filed", "patentsFiled"],
  //       patentsGrantedNational: ["patents_granted_national", "patentsGrantedNational"],
  //       patentsGrantedInternational: ["patents_granted_international", "patentsGrantedInternational"],
  //       patentsCommercialized: ["patents_commercialized", "patentsCommercialized"],
  //       investmentActivities: ["investment_activities", "investmentActivities"],
  //       investmentElectrolyser: ["investment_electrolyser", "investmentElectrolyser"],
  //       upcomingProjects: ["upcoming_projects", "upcomingProjects"],
  //     };

  //     Object.entries(quantBases).forEach(([frontBase, candidates]) => {
  //       const front2024 = `${frontBase}2024`;
  //       const front2023 = `${frontBase}2023`;

  //       let v24, v23;
  //       for (const c of candidates) {
  //         v24 = v24 ?? get(`${c}_2024`, `${c}2024`);
  //         v23 = v23 ?? get(`${c}_2023`, `${c}2023`);
  //       }
  //       // fallback: plain base -> treat as 2024 if no explicit year
  //       if (v24 === undefined) {
  //         for (const c of candidates) {
  //           v24 = v24 ?? _ResData[c];
  //         }
  //       }

  //       newFields[front2024] = safeStr(v24);
  //       newFields[front2023] = safeStr(v23);

  //       // Also set the exact keys your handleSubmit uses (explicit names)
  //       // Map some of the common explicit keys to the frontend names that appear in handleSubmit
  //       switch (frontBase) {
  //         case "installedCapacity":
  //           newFields.installedCapacity2024 = safeStr(v24);
  //           break;
  //         case "production":
  //           newFields.production2024 = safeStr(v24);
  //           break;
  //         case "carbonEmission":
  //           newFields.carbonEmission2024 = safeStr(v24);
  //           break;
  //         case "purity":
  //           newFields.purity2024 = safeStr(v24);
  //           break;
  //         case "costOfProduction":
  //           newFields.costOfProduction2024 = safeStr(v24);
  //           break;
  //         case "patentsFiled":
  //           newFields.patentsFiled2024 = safeStr(v24);
  //           break;
  //         case "patentsGrantedNational":
  //           newFields.patentsGrantedNational2024 = safeStr(v24);
  //           break;
  //         case "patentsGrantedInternational":
  //           newFields.patentsGrantedInternational2024 = safeStr(v24);
  //           break;
  //         case "patentsCommercialized":
  //           newFields.patentsCommercialized2024 = safeStr(v24);
  //           break;
  //         case "investmentActivities":
  //           newFields.investmentActivities2024 = safeStr(v24);
  //           newFields.investmentActivities2023 = safeStr(v23);
  //           break;
  //         case "investmentElectrolyser":
  //           newFields.investmentElectrolyser2024 = safeStr(v24);
  //           newFields.investmentElectrolyser2023 = safeStr(v23);
  //           break;
  //         case "upcomingProjects":
  //           newFields.upcomingProjects2024 = safeStr(v24);
  //           newFields.upcomingProjects2023 = safeStr(v23);
  //           break;
  //         default:
  //           break;
  //       }
  //     });

  //     // Projects 1..5 (flat fields)
  //     for (let i = 1; i <= 5; i++) {
  //       newFields[`projectName${i}`] =
  //         get(`project_name_${i}`, `projectName${i}`, `project_name${i}`, `project${i}_name`, `project_${i}_name`) ?? "";
  //       newFields[`location${i}`] =
  //         get(`location_${i}`, `location${i}`, `project_location_${i}`, `projectLocation${i}`) ?? "";
  //       newFields[`capacity${i}`] = safeStr(get(`capacity_${i}`, `capacity${i}`, `project_capacity_${i}`) ?? "");
  //       newFields[`projectCompletionYear${i}`] =
  //         get(`project_completion_year_${i}`, `projectCompletionYear${i}`, `completion_year_${i}`) ?? "";
  //       newFields[`projectCurrentStatus${i}`] =
  //         get(`project_current_status_${i}`, `projectCurrentStatus${i}`, `project_status_${i}`) ?? "";
  //     }

  //     // Attachments 1..4: description + url + keep file null
  //     for (let n = 1; n <= 4; n++) {
  //       const descKeys = [`attachments${n}_desc`, `attachments${n}Desc`, `attachment${n}_desc`, `attachment${n}Desc`];
  //       const fileKeys = [`attachments${n}`, `attachments${n}_url`, `attachments${n}_file`, `attachment${n}`, `attachment${n}_url`];

  //       let desc = "";
  //       for (const k of descKeys) {
  //         if (_ResData[k] !== undefined && _ResData[k] !== null) {
  //           desc = _ResData[k];
  //           break;
  //         }
  //       }

  //       let url = null;
  //       for (const k of fileKeys) {
  //         if (_ResData[k] !== undefined && _ResData[k] !== null && _ResData[k] !== "") {
  //           url = _ResData[k];
  //           break;
  //         }
  //       }

  //       // fallback: attachments array/object
  //       if (!url && Array.isArray(_ResData.attachments)) {
  //         const arrItem = _ResData.attachments[n - 1];
  //         if (arrItem) {
  //           url = arrItem.url ?? arrItem.file ?? arrItem.file_url ?? arrItem.attachment_url ?? null;
  //           desc = desc || arrItem.description || arrItem.desc || "";
  //         }
  //       }

  //       newFields[`attachments${n}`] = {
  //         description: desc ?? "",
  //         file: null, // keep null until user re-selects a File
  //         url: url ?? null,
  //       };
  //     }

  //     // Approving authority signature preview url (keep file null)
  //     newFields.approvingAuthoritySignature = null;
  //     newFields.approvingAuthoritySignatureUrl =
  //       get(
  //         "approving_authority_file",
  //         "approving_authority_file_url",
  //         "approvingAuthorityFileUrl",
  //         "approving_authority_signature",
  //         "approving_authority_signature_url"
  //       ) ?? null;

  //     // Copy leftover keys that look like *_2024 or *_2023 into state (stringified)
  //     Object.keys(_ResData).forEach((k) => {
  //       if (/_2024$|_2023$|2024$|2023$/.test(k) && !Object.prototype.hasOwnProperty.call(newFields, k)) {
  //         newFields[k] = safeStr(_ResData[k]);
  //       }
  //     });

  //     // Merge immutably into formData
  //     setFormData((prev) => ({ ...prev, ...newFields }));

  //     console.log("prefillFormData applied for green-hydrogen, pk:", pk);
  //     return _ResData;
  //   } catch (err) {
  //     console.error("prefillFormData error:", err);
  //     // don't throw if you prefer silent failure; throw if you want upstream to handle errors
  //     throw err;
  //   }
  // }

  async function prefillFormData() {
    if (!userInfo || !formId) {
      console.warn("prefillFormData: missing userInfo or formId");
      return;
    }

    const url = `/green-hydrogen/?user_id=${encodeURIComponent(
      userInfo.id
    )}&form_id=${encodeURIComponent(formId)}`;

    try {
      const res = await apiClient.get(url);
      if (!Array.isArray(res.data) || res.data.length !== 1) {
        console.log("No single prefill item found:", res.data);
        return;
      }
      const _ResData = res.data[0];

      // Primary PK
      const pk = _ResData.id ?? _ResData.pk ?? _ResData.pk_id ?? 0;
      setPkId(pk);

      // helpers
      const safeStr = (v) => (v === null || v === undefined ? "" : String(v));
      const get = (...keys) => {
        for (const k of keys) {
          if (_ResData[k] !== undefined && _ResData[k] !== null)
            return _ResData[k];
        }
        return undefined;
      };

      // Try to turn a server-provided path into a usable URL for preview.
      // Handles absolute URLs, '/...' paths, and relative paths (tries /media/..., /<path>, and prepends apiClient base origin if available).
      const buildAbsoluteUrl = (candidate) => {
        if (!candidate) return null;
        if (typeof candidate !== "string") return null;
        const trimmed = candidate.trim();
        if (!trimmed) return null;
        // already absolute
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        // already root-absolute
        if (trimmed.startsWith("/")) return trimmed;
        // try /media/<path> (common Django media)
        const mediaPath = `/media/${trimmed.replace(/^\/+/, "")}`;
        // try /<path>
        const rootPath = `/${trimmed.replace(/^\/+/, "")}`;

        // If apiClient has a baseURL, try to synthesize an absolute URL using its origin
        try {
          const base = apiClient?.defaults?.baseURL;
          if (base) {
            // get origin (protocol + host + optional port)
            const origin = new URL(base, window.location.origin).origin;
            return `${origin}${mediaPath}`;
          }
        } catch (e) {
          // fallthrough to return mediaPath
        }
        // fallback to mediaPath (will be relative to current origin)
        return mediaPath;
      };

      // Basic mapping (identity / contact / meta)
      const newFields = {
        userid:
          get("userid", "user_id", "user", "created_by") ?? userInfo?.id ?? "",
        firstname: get("firstname", "first_name") ?? userInfo?.first_name ?? "",
        lastname: get("lastname", "last_name") ?? userInfo?.last_name ?? "",
        Organisationname:
          get(
            "organisation_name",
            "organisationName",
            "company_name",
            "companyName"
          ) ??
          userInfo?.organisation_name ??
          "",
        companyName: get("company_name", "companyName") ?? "",
        company_name: get("company_name", "companyName") ?? "",
        category: get("category") ?? "",
        form_id: get("form_id") ?? formId,
        form_mode: get("form_mode", "formMode") ?? "draft",
        comment: get("comment", "notes", "remarks") ?? "",
        created_at: get("created_at", "createdAt") ?? null,
        updated_at: get("updated_at", "updatedAt") ?? null,
        mailingAddress:
          get("mailing_address", "mailingAddress", "address") ?? "",
        contact_name: get("contact_name", "contactName") ?? "",
        contact_phone: safeStr(get("contact_phone", "contactPhone") ?? ""),
        contact_email: get("contact_email", "contactEmail") ?? "",
        applicant_name:
          get("applicant_name", "applicantName", "applicant") ?? "",
        applicant_phone: safeStr(
          get("applicant_phone", "applicantPhone") ?? ""
        ),
        applicant_email: get("applicant_email", "applicantEmail") ?? "",
        authorityName:
          get("authority_name", "authorityName", "approving_authority_name") ??
          "",
        authorityTitle:
          get(
            "authority_title",
            "authorityTitle",
            "approving_authority_title"
          ) ?? "",
        authorityPhone: safeStr(
          get(
            "authority_phone",
            "authorityPhone",
            "approving_authority_phone"
          ) ?? ""
        ),
        authorityLandline: safeStr(
          get("authority_landline", "authorityLandline") ?? ""
        ),
        authorityEmail: get("authority_email", "authorityEmail") ?? "",
        companyProfile:
          get("company_profile", "companyProfile", "company_description") ?? "",
        awardJustification:
          get("award_justification", "awardJustification") ?? "",
        declaration:
          (get("declaration") === true || get("declaration") === "true") ??
          false,
      };

      // Quantitative mapping (2024/2023) — keep keys your handleSubmit expects
      const quantBases = {
        installedCapacity: ["installed_capacity", "installedCapacity"],
        production: ["production"],
        carbonEmission: ["carbon_emission", "carbonEmission"],
        purity: ["purity"],
        costOfProduction: ["cost_of_production", "costOfProduction"],
        patentsFiled: ["patents_filed", "patentsFiled"],
        patentsGrantedNational: [
          "patents_granted_national",
          "patentsGrantedNational",
        ],
        patentsGrantedInternational: [
          "patents_granted_international",
          "patentsGrantedInternational",
        ],
        patentsCommercialized: [
          "patents_commercialized",
          "patentsCommercialized",
        ],
        investmentActivities: ["investment_activities", "investmentActivities"],
        investmentElectrolyser: [
          "investment_electrolyser",
          "investmentElectrolyser",
        ],
        upcomingProjects: ["upcoming_projects", "upcomingProjects"],
      };

      Object.entries(quantBases).forEach(([frontBase, candidates]) => {
        const front2024 = `${frontBase}2024`;
        const front2023 = `${frontBase}2023`;
        let v24, v23;

        for (const c of candidates) {
          v24 = v24 ?? get(`${c}_2024`, `${c}2024`);
          v23 = v23 ?? get(`${c}_2023`, `${c}2023`);
        }
        // fallback: plain base -> treat as 2024 if no explicit year
        if (v24 === undefined) {
          for (const c of candidates) {
            v24 = v24 ?? _ResData[c];
          }
        }

        newFields[front2024] = safeStr(v24);
        newFields[front2023] = safeStr(v23);

        // also set explicit frontend names used by handleSubmit
        switch (frontBase) {
          case "installedCapacity":
            newFields.installedCapacity2024 = safeStr(v24);
            break;
          case "production":
            newFields.production2024 = safeStr(v24);
            break;
          case "carbonEmission":
            newFields.carbonEmission2024 = safeStr(v24);
            break;
          case "purity":
            newFields.purity2024 = safeStr(v24);
            break;
          case "costOfProduction":
            newFields.costOfProduction2024 = safeStr(v24);
            break;
          case "patentsFiled":
            newFields.patentsFiled2024 = safeStr(v24);
            break;
          case "patentsGrantedNational":
            newFields.patentsGrantedNational2024 = safeStr(v24);
            break;
          case "patentsGrantedInternational":
            newFields.patentsGrantedInternational2024 = safeStr(v24);
            break;
          case "patentsCommercialized":
            newFields.patentsCommercialized2024 = safeStr(v24);
            break;
          case "investmentActivities":
            newFields.investmentActivities2024 = safeStr(v24);
            newFields.investmentActivities2023 = safeStr(v23);
            break;
          case "investmentElectrolyser":
            newFields.investmentElectrolyser2024 = safeStr(v24);
            newFields.investmentElectrolyser2023 = safeStr(v23);
            break;
          case "upcomingProjects":
            newFields.upcomingProjects2024 = safeStr(v24);
            newFields.upcomingProjects2023 = safeStr(v23);
            break;
          default:
            break;
        }
      });

      // Projects 1..5 (flat fields)
      for (let i = 1; i <= 5; i++) {
        newFields[`projectName${i}`] =
          get(
            `project_name_${i}`,
            `projectName${i}`,
            `project_name${i}`,
            `project${i}_name`,
            `project_${i}_name`
          ) ?? "";
        newFields[`location${i}`] =
          get(
            `location_${i}`,
            `location${i}`,
            `project_location_${i}`,
            `projectLocation${i}`
          ) ?? "";
        newFields[`capacity${i}`] = safeStr(
          get(`capacity_${i}`, `capacity${i}`, `project_capacity_${i}`) ?? ""
        );
        newFields[`projectCompletionYear${i}`] =
          get(
            `project_completion_year_${i}`,
            `projectCompletionYear${i}`,
            `completion_year_${i}`
          ) ?? "";
        newFields[`projectCurrentStatus${i}`] =
          get(
            `project_current_status_${i}`,
            `projectCurrentStatus${i}`,
            `project_status_${i}`
          ) ?? "";
      }

      // ---------- Robust attachments parsing (1..4) ----------
      // Normalize to: { description, file: null, url, name?, size?, content_type? }
      for (let n = 1; n <= 4; n++) {
        // description candidates
        const descCandidates = [
          `attachments${n}_desc`,
          `attachments${n}Desc`,
          `attachment${n}_desc`,
          `attachment${n}Desc`,
          `attachments_${n}_desc`,
          `attachment_${n}_desc`,
        ];
        let desc = "";
        for (const k of descCandidates) {
          if (_ResData[k] !== undefined && _ResData[k] !== null) {
            desc = _ResData[k];
            break;
          }
        }

        // file/url candidates
        const fileCandidates = [
          `attachments${n}`,
          `attachments_${n}`,
          `attachment${n}`,
          `attachment_${n}`,
          `attachments${n}_url`,
          `attachments${n}_file`,
          `attachment${n}_url`,
          `attachment${n}_file`,
          `attachments${n}_file_url`,
          `attachment${n}_file_url`,
        ];

        let found = undefined;
        for (const k of fileCandidates) {

          if (
            _ResData[k] !== undefined &&
            _ResData[k] !== null &&
            _ResData[k] !== ""
          ) {
            found = _ResData[k];
            break;
          }
        }

        // fallback: attachments array/object
        if (
          (!found || found === "") &&
          Array.isArray(_ResData.attachments) &&
          _ResData.attachments.length >= n
        ) {
          found = _ResData.attachments[n - 1];
        }

        let normalized = {
          description: desc ?? "",
          file: null,
          url: null,
          name: null,
          size: null,
          content_type: null,
        };

        if (found) {
          if (typeof found === "string") {
            // raw path or url
            normalized.url = buildAbsoluteUrl(found);
            // try to extract filename
            try {
              const parts = found.split("/").filter(Boolean);
              normalized.name = decodeURIComponent(
                parts[parts.length - 1].split("?")[0]
              );
            } catch (e) {
              normalized.name = null;
            }
          } else if (Array.isArray(found)) {
            const item = found[0];
            if (typeof item === "string") {
              normalized.url = buildAbsoluteUrl(item);
            } else if (item && typeof item === "object") {
              normalized.url = buildAbsoluteUrl(
                item.url ??
                  item.file ??
                  item.file_url ??
                  item.attachment_url ??
                  null
              );
              normalized.name =
                item.name ?? item.filename ?? item.original_filename ?? null;
              normalized.size = item.size ?? item.file_size ?? null;
              normalized.content_type =
                item.content_type ?? item.mimetype ?? item.mime_type ?? null;
              normalized.description =
                normalized.description || item.description || item.desc || "";
            }
          } else if (typeof found === "object") {
            normalized.url = buildAbsoluteUrl(
              found.url ??
                found.file ??
                found.file_url ??
                found.attachment_url ??
                null
            );
            normalized.name =
              found.name ??
              found.filename ??
              found.original_filename ??
              found.title ??
              null;
            normalized.size =
              found.size ?? found.file_size ?? found.length ?? null;
            normalized.content_type =
              found.content_type ?? found.mimetype ?? found.mime_type ?? null;
            normalized.description =
              normalized.description || found.description || found.desc || "";
          }
        }

        newFields[`attachments${n}`] = normalized;
      }

      // Approving authority signature: keep file null, set url/name if present
      const sigCandidates = [
        "approving_authority_file",
        "approving_authority_file_url",
        "approvingAuthorityFileUrl",
        "approving_authority_signature",
        "approving_authority_signature_url",
        "approvingAuthoritySignatureUrl",
        "approvingAuthoritySignature",
        "approving_authority_signature_file",
      ];
      let sigVal = null;
      for (const k of sigCandidates) {
        if (
          _ResData[k] !== undefined &&
          _ResData[k] !== null &&
          _ResData[k] !== ""
        ) {
          sigVal = _ResData[k];
          break;
        }
      }
      let sigNormalized = null;
      if (sigVal) {
        if (typeof sigVal === "string") {
          sigNormalized = {
            url: buildAbsoluteUrl(sigVal),
            name: (() => {
              try {
                const p = sigVal.split("/").filter(Boolean);
                return decodeURIComponent(p[p.length - 1].split("?")[0]);
              } catch (e) {
                return null;
              }
            })(),
          };
        } else if (typeof sigVal === "object") {
          sigNormalized = {
            url: buildAbsoluteUrl(
              sigVal.url ?? sigVal.file ?? sigVal.file_url ?? null
            ),
            name:
              sigVal.name ??
              sigVal.filename ??
              sigVal.original_filename ??
              null,
            size: sigVal.size ?? sigVal.file_size ?? null,
            content_type: sigVal.content_type ?? sigVal.mimetype ?? null,
          };
        }
      }
      newFields.approvingAuthoritySignature = null;
      newFields.approvingAuthoritySignatureUrl = sigNormalized?.url ?? null;
      newFields.approvingAuthoritySignatureName = sigNormalized?.name ?? null;

      // Copy leftover *_2024 or *_2023 keys as strings
      Object.keys(_ResData).forEach((k) => {
        if (
          /_2024$|_2023$|2024$|2023$/.test(k) &&
          !Object.prototype.hasOwnProperty.call(newFields, k)
        ) {
          newFields[k] = safeStr(_ResData[k]);
        }
      });

      // Merge into state
      setFormData((prev) => ({ ...prev, ...newFields }));
      console.log("prefillFormData applied for green-hydrogen, pk:", pk);

      return _ResData;
    } catch (err) {
      console.error("prefillFormData error:", err);
      // keep previous behavior: rethrow so callers can handle if they expect it
      throw err;
    }
  }

  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const awardTitle =
    location.state?.awardTitle || "Green Hydrogen Company of the Year";

  const clearFieldError = (field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  };

  const validateEmail = (email) => emailRegex.test(email);

  const validatePhone = (phone) => phoneRegex.test(phone);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if ([1, 2, 4].includes(currentStep)) {
      let applicableMaxLength = FIELD_MAX_LENGTH;
      if (name === "companyProfile")
        applicableMaxLength = COMPANY_PROFILE_MAX_LENGTH;
      else if (name === "comment") applicableMaxLength = COMMENT_MAX_LENGTH;

      if (typeof value === "string") {
        if (name === "companyProfile") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed.");
            return;
          }
        } else if (name === "comment") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed in Comments.");
            return;
          }
        } 
      }
    } else {
      // For Steps 3 and 4, no max-length alerts
      clearFieldError(name);
    }
    if (name === "authorityPhone" || name === "contact_phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, PHONE_MAX_LENGTH);
      if (numericValue.length > PHONE_MAX_LENGTH) {
        alert("Phone number must not exceed 10 digits.");
        return;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      clearFieldError(name);
      return;
    }
    if (
      [
        "Organisationname",
        "companyName",
        "authorityName",
        "contact_name",
        "Applicantdesignation",
      ].includes(name)
    ) {
      const isValid = /^[A-Za-z\s]*$/.test(value);
      if (!isValid && value !== "") {
        alert("Only letters and spaces are allowed.");
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "Organisationname" && value && currentStep === 1) setError("");
    if (name === "mailingAddress" && value.trim() && currentStep === 1)
      setError("");
  };

  const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    // setCopyApplicantData(checked);

    const model = {
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    };

    if (checked) {
      const userInfo = JSON.parse(sessionStorage.getItem("user_info"));
      if (userInfo) {
        model.contact_name = userInfo.applicant_name;
        model.contact_phone = userInfo.applicant_phone;
        model.contact_email = userInfo.email;
      }
    }

    setFormData((prev) => ({ ...prev, ...model }));

    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === "file" && value) {
      const file = value;
      const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
      if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for attachments.");
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for attachments.");
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const handleApprovingAuthorityChange = (files) => {
    setFormData((prev) => ({
      ...prev,
      approvingAuthoritySignature: files[0],
    }));
  };

  const nextStep = () => {
    if (currentStep === 1) {
      if (!formData.mailingAddress.trim()) {
        alert("Mailing address is required.");
        return;
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        alert("Authority name is required.");
        return;
      }
      if (!formData.authorityTitle) {
        alert("Authority designation is required.");
        return;
      }
      if (!formData.authorityEmail || !validateEmail(formData.authorityEmail)) {
        alert("Please enter a valid Authority email.");
        return;
      }
      if (!formData.authorityLandline) {
        alert("Authority Landline is required.");
        return;
      }
      if (!formData.contact_name) {
        alert("Contact name is required.");
        return;
      }
      if (formData.contact_email && !validateEmail(formData.contact_email)) {
        alert("Please enter a valid Contact email.");
        return;
      }
      if (
        formData.contact_phone &&
        !validatePhone(formData.contact_phone) &&
        !copyApplicantData
      ) {
        alert("Contact phone must be exactly 10 digits.");
        return;
      }
      if (!formData.companyProfile) {
        alert("Company Profile is required.");
        return;
      }
    }
    if (currentStep === 3 && hasEmptyFieldsStep3()) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return;
      }
    }

    if (currentStep === 4 && hasEmptyFieldsStep4()) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return;
      }
    }

    setError("");
    if (currentStep < 5) setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem(
      "registrationGreenHydrogenDraft",
      JSON.stringify({ formData })
    );
    handleSubmit(null);
    alert("Draft Saved!");
  };

  //Final Submit button

  const finalSubmit = () => {
    handleSubmit(null, "submited");
  };

  async function handleSubmit(event, clickType = "draft") {
    if (event && event.preventDefault) event.preventDefault();
    console.log(
      "############################ Save the DAta on Server ##########################"
    );

    // Local copy of form
    let payload = { ...formData };

    // Merge user_info synchronously
    try {
      const raw = localStorage.getItem("user_info");
      if (raw) {
        const u = JSON.parse(raw);
        payload.userid = u.id ?? payload.userid;
        payload.firstname = u.first_name ?? payload.firstname;
        payload.lastname = u.last_name ?? payload.lastname;
        payload.company_name = u.Organisationname ?? payload.Organisationname;
        payload.Organisationname =
          u.organisation_name ?? payload.Organisationname;
      }
    } catch (err) {
      console.warn("Failed to load user_info:", err);
    }

    const fd = new FormData();

    // Explicitly map frontend keys → backend keys (use payload so merged values are used)
    fd.append("organisation_name", payload.Organisationname || "");
    fd.append(
      "company_name",
      payload.companyName || payload.Organisationname || ""
    );
    fd.append("category", payload.category || "");
    fd.append("firstname", payload.firstname || "");
    fd.append("lastname", payload.lastname || "");
    fd.append("mailing_address", payload.mailingAddress || "");
    fd.append("authority_name", payload.authorityName || "");
    fd.append("authority_title", payload.authorityTitle || "");
    fd.append("authority_phone", payload.authorityPhone || "");
    fd.append("authorityLandline", payload.authorityLandline || "");
    fd.append("authority_email", payload.authorityEmail || "");
    fd.append("contact_name", payload.contact_name || "");
    fd.append("contact_phone", payload.contact_phone || "");
    fd.append("contact_email", payload.contact_email || "");
    fd.append("company_profile", payload.companyProfile || "");
    fd.append("comment", payload.comment || "");
    fd.append("declaration", payload.declaration ? "true" : "false");

    // Form meta
    fd.append("form_id", formId || "");
    fd.append("form_mode", clickType || payload.form_mode || "draft");

    // If we already know PK -> include id so server updates instead of creating a new record
    if (PkId && Number(PkId) > 0) {
      fd.append("id", String(PkId));
    }

    // Approving authority signature (file)
    const sigFile =
      payload.approvingAuthoritySignature ??
      formData.approvingAuthoritySignature;
    if (sigFile instanceof File) {
      fd.append("approving_authority_file", sigFile);
    }

    // Quantitative fields (use payload values)
    fd.append("installed_capacity_2024", payload.installedCapacity2024 ?? "");
    fd.append("production_2024", payload.production2024 ?? "");
    fd.append("carbon_emission_2024", payload.carbonEmission2024 ?? "");
    fd.append("purity_2024", payload.purity2024 ?? "");
    fd.append("cost_of_production_2024", payload.costOfProduction2024 ?? "");
    fd.append("patents_filed_2024", payload.patentsFiled2024 ?? "");
    fd.append(
      "patents_granted_national_2024",
      payload.patentsGrantedNational2024 ?? ""
    );
    fd.append(
      "patents_granted_international_2024",
      payload.patentsGrantedInternational2024 ?? ""
    );
    fd.append(
      "patents_commercialized_2024",
      payload.patentsCommercialized2024 ?? ""
    );
    fd.append(
      "investment_activities_2024",
      payload.investmentActivities2024 ?? ""
    );
    fd.append(
      "investment_activities_2023",
      payload.investmentActivities2023 ?? ""
    );
    fd.append(
      "investment_electrolyser_2024",
      payload.investmentElectrolyser2024 ?? ""
    );
    fd.append(
      "investment_electrolyser_2023",
      payload.investmentElectrolyser2023 ?? ""
    );
    fd.append("upcoming_projects_2024", payload.upcomingProjects2024 ?? "");
    fd.append("upcoming_projects_2023", payload.upcomingProjects2023 ?? "");

    // Attachments (desc + file)
    [1, 2, 3, 4].forEach((n) => {
      const att = payload[`attachments${n}`] || {};
      fd.append(`attachments${n}_desc`, att.description || "");
      if (att.file instanceof File) fd.append(`attachments${n}`, att.file);
    });

    // Projects 1..5
    for (let i = 1; i <= 5; i++) {
      fd.append(`project_name_${i}`, payload[`projectName${i}`] ?? "");
      fd.append(`location_${i}`, payload[`location${i}`] ?? "");
      fd.append(`capacity_${i}`, payload[`capacity${i}`] ?? "");
      fd.append(
        `project_completion_year_${i}`,
        payload[`projectCompletionYear${i}`] ?? ""
      );
      fd.append(
        `project_current_status_${i}`,
        payload[`projectCurrentStatus${i}`] ?? ""
      );
    }

    try {
      // Do NOT set Content-Type manually when sending FormData — axios will set the proper boundary.
      const response = await apiClient.post(
        "/green-hydrogen/",
        fd /*, { headers: { "Content-Type": "multipart/form-data" } }*/
      );

      // RESPONSE HANDLING: set PkId immediately from server response so subsequent saves will update
      // response may be { message, data } as your view returns. Normalize:
      const returned = response?.data?.data
        ? response.data.data
        : response?.data ?? null;
      const returnedId =
        returned?.id ?? returned?.pk ?? returned?.pk_id ?? null;
      if (returnedId) {
        setPkId(returnedId);
        // also keep the form state aware that it's now saved
        setFormData((prev) => ({
          ...prev,
          id: returnedId,
          form_mode: returned?.form_mode ?? clickType,
        }));
      }

      // Refresh saved data & previews
      await prefillFormData();

      return response;
    } catch (err) {
      console.error("green-hydrogen submission error:", err);
      const serverMsg =
        err?.response?.data ?? err?.message ?? JSON.stringify(err);
      // If server returned unique constraint style error, show it plainly
      if (err?.response?.status === 400 || err?.response?.status === 409) {
        alert("Submission failed: " + JSON.stringify(serverMsg));
      } else {
        alert("Submission failed: " + JSON.stringify(serverMsg));
      }
      throw err;
    }
  }

  const handlePrint = () => {
    const printContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <h1 style="text-align: center; color: #1e40af;">${awardTitle}</h1>
      <h2>Organization & Contact Details</h2>
      <p><strong>Organisation Name:</strong> ${
        formData.Organisationname || ""
      }</p>
      <p><strong>Postal Address:</strong> ${formData.mailingAddress || ""}</p>
      <p><strong>Approving Authority Name:</strong> ${
        formData.authorityName || ""
      }</p>
      <p><strong>Approving Authority Designation:</strong> ${
        formData.authorityTitle || ""
      }</p>
      <p><strong>Approving Authority Landline:</strong> ${
        formData.authorityLandline || ""
      }</p>
      <p><strong>Approving Authority Phone:</strong> ${
        formData.authorityPhone || ""
      }</p>
      <p><strong>Approving Authority Email:</strong> ${
        formData.authorityEmail || ""
      }</p>

      <h2>Nodal Official Contact Details:</h2>
      <p><strong>Contact Name:</strong> ${formData.contact_name || ""}</p>
      <p><strong>Contact Phone:</strong> ${formData.contact_phone || ""}</p>
      <p><strong>Contact Email:</strong> ${formData.contact_email || ""}</p>
      <p><strong>Brief write up on company’s profile:</strong> ${
        formData.companyProfile || ""
      }</p>

      <h2>Quantitative Information</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Particulars</th>
            <th style="border: 1px solid #000; padding: 8px;">2024-25</th>
            <th style="border: 1px solid #000; padding: 8px;">2023-24</th>
          </tr>
        </thead>
        <tbody>
          ${data
            .map(
              ({ num, title, key2024, key2023 }) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${num}</td>
              <td style="border: 1px solid #000; padding: 8px;">${title}</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[key2024] || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                key2023 ? formData[key2023] || "" : "N/A"
              }</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Upcoming Projects</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Project Name</th>
            <th style="border: 1px solid #000; padding: 8px;">Location</th>
            <th style="border: 1px solid #000; padding: 8px;">Capacity (MT)</th>
            <th style="border: 1px solid #000; padding: 8px;">Completion Year</th>
            <th style="border: 1px solid #000; padding: 8px;">Current Status</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4, 5]
            .map(
              (i) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${i}</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`projectName${i}`] || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`location${i}`] || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`capacity${i}`] || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`projectCompletionYear${i}`] || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`projectCurrentStatus${i}`] || ""
              }</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Attachments</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 16px;">
        <thead>
          <tr>
            <th style="border: 1px solid #000; padding: 8px;width:10px">S.No</th>
            <th style="border: 1px solid #000; padding: 8px;">Description</th>
            <th style="border: 1px solid #000; padding: 8px;">File Name</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4]
            .map(
              (i) => `
            <tr>
              <td style="border: 1px solid #000; padding: 8px;">${i}</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`attachments${i}`].description || ""
              }</td>
              <td style="border: 1px solid #000; padding: 8px;">${
                formData[`attachments${i}`].file?.name || ""
              }</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <h2>Comments</h2>
      <p>${formData.comment || ""}</p>

      <h2>Declaration</h2>
      <p>I declare that the information submitted is true and complete.</p>
      <br/>
      <p><strong>Approving Authority Name:</strong> ${
        formData.authorityName || ""
      }</p>
      <p><strong>Approving Authority Designation:</strong> ${
        formData.authorityTitle || ""
      }</p>
      <p><strong>Signed on:</strong> ${
        formData.signatureDate || new Date().toLocaleDateString()
      }</p>
      <p><strong>Approving Authority Signature:</strong></p>
    </div>
  `;

    // ✅ Add a title to remove "about:blank"
    const printWindow = window.open("", "_blank", "height=600,width=800");
    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <title>${awardTitle || "Print View"}</title>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
  };

  const data = [
    {
      num: 1,
      title: "Installed Capacity of Green hydrogen production units (MT)",
      key2024: "installedCapacity2024",
    },
    {
      num: 2,
      title: "Production of Green hydrogen (MT)",
      key2024: "production2024",
    },
    {
      num: 3,
      title:
        "Carbon emitted per unit of Green Hydrogen Production (Tonne/Tonne)",
      key2024: "carbonEmission2024",
    },
    {
      num: 4,
      title: "Purity of Green Hydrogen Produced (%)",
      key2024: "purity2024",
    },
    {
      num: 5,
      title: "Cost of Production (INR / Tonne)",
      key2024: "costOfProduction2024",
    },
    {
      num: 6,
      title: "Patents filed in the Assessment year",
      key2024: "patentsFiled2024",
    },
    {
      num: 7,
      title: "Total Patents Granted (National)",
      key2024: "patentsGrantedNational2024",
    },
    {
      num: 8,
      title: "Total Patents Granted (International)",
      key2024: "patentsGrantedInternational2024",
    },
    {
      num: 9,
      title: "Patents Commercialized",
      key2024: "patentsCommercialized2024",
    },
    {
      num: 10,
      title:
        "Investment in Green Hydrogen Activities - production/transportation/distribution/storage (INR Crore)",
      key2024: "investmentActivities2024",
      key2023: "investmentActivities2023",
    },
    {
      num: 11,
      title: "Investment in Electrolyser/ Membrane Manufacturing (INR Crore)",
      key2024: "investmentElectrolyser2024",
      key2023: "investmentElectrolyser2023",
    },
  ];

  const hasEmptyFieldsStep3 = () => {
    // Check inputs in Step 3: data indexes 0 to 8 (inclusive) for 2024 only (per your code)
    for (let i = 0; i <= 8; i++) {
      const key2024 = data[i]?.key2024;
      if (key2024) {
        const val = formData[key2024];
        if (val === "" || val === undefined || val === null) {
          return true;
        }
      }
    }
    return false;
  };

  const hasEmptyFieldsStep4 = () => {
    // Check inputs in Step 4: data indexes 9 to 11 for both years (2024 and 2023)
    for (let i = 9; i <= 11; i++) {
      const key2024 = data[i]?.key2024;
      const key2023 = data[i]?.key2023;
      if (key2024) {
        const val = formData[key2024];
        if (val === "" || val === undefined || val === null) {
          return true;
        }
      }
      if (key2023) {
        const val = formData[key2023];
        if (val === "" || val === undefined || val === null) {
          return true;
        }
      }
    }
    // Check project inputs in Step 4 (projectName, location, etc.)
    for (let i = 1; i <= 5; i++) {
      const fields = [
        `projectName${i}`,
        `location${i}`,
        `capacity${i}`,
        `projectCompletionYear${i}`,
        `projectCurrentStatus${i}`,
      ];
      for (const key of fields) {
        const val = formData[key];
        if (val === "" || val === undefined || val === null) {
          return true;
        }
      }
    }

    return false;
  };
  // async function viewFile(serverPath) {
  //   if (!serverPath) return;
  //   try {
  //     // fetch via apiClient so auth headers/cookies are used (no direct navigation to backend path)
  //     const resp = await apiClient.get(serverPath, { responseType: "blob" });
  //     const blob = resp.data;
  //     const blobUrl = URL.createObjectURL(blob);

  //     // open the blob URL in a new tab — this does NOT expose your backend path to the user
  //     window.open(blobUrl, "_blank", "noopener,noreferrer");

  //     // revoke the blob URL after a minute to free memory (adjust if you want)
  //     setTimeout(() => {
  //       try {
  //         URL.revokeObjectURL(blobUrl);
  //       } catch (e) {
  //         /* ignore */
  //       }
  //     }, 60000);
  //   } catch (err) {
  //     console.error("Preview failed:", err);
  //     alert("Unable to preview file. See console for details.");
  //   }
  // }

  const viewFile =  async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath.split('/').filter(
  (val) =>
    val !== "" && // remove empty strings
    val !== "http:" &&
    val !== "https:" &&
    val !== "media" &&
    !val.startsWith("award") &&
    !val.startsWith("localhost")
).join('/');
    
    downloadFile(extractPath)
  }

  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;

    return (
      <div className="form-step">
        <div className="progress-bar">
          <div className="progress" style={{ width: `${progress}%` }} />
        </div>

        {/* Step 1 */}
        {currentStep === 1 && (
          <>
            <h3 className="step-title">Step 1: Organization Details</h3>

            <div className="form-group">
              <label>
                Organisation Name:
                {/* <span className="text-red">*</span> */}
              </label>
              <input
                type="text"
                name="Organisationname"
                value={formData.Organisationname}
                // onChange={handleChange}
                disabled={true}
                maxLength={FIELD_MAX_LENGTH}
                className={`form-input ${
                  !formData.Organisationname && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
              />
              {fieldErrors.Organisationname && (
                <span className="error-tooltip">
                  {fieldErrors.Organisationname}
                </span>
              )}
              {/* {!formData.Organisationname && currentStep === 1 && <span className="error-tooltip">Organisation name is required</span>} */}
            </div>

            <div className="form-group">
              <label>
                Postal Address:<span className="text-red">*</span>
              </label>
              <textarea
                name="mailingAddress"
                value={formData.mailingAddress}
                onChange={handleChange}
                maxLength={FIELD_MAX_LENGTH}
                rows={3}
                placeholder="Enter Postal address"
                className={`form-textarea ${
                  !formData.mailingAddress.trim() && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
              />
              {fieldErrors.mailingAddress && (
                <span className="error-tooltip">
                  {fieldErrors.mailingAddress}
                </span>
              )}
              {!formData.mailingAddress.trim() && currentStep === 1 && (
                <span className="error-tooltip">
                  Mailing address is required
                </span>
              )}
            </div>
          </>
        )}

        {/* Step 2 */}
        {currentStep === 2 && (
          <>
            <h3 className="step-title">
              Step 2: Approving Authority & Contact
            </h3>
            {/* Authority and Contact form inputs with maxLength and placeholders*/}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="step-section">
                <h4>Approving Authority</h4>
                <p className="note">
                  Approving authority should be concerned Director /Board level
                  executive.{" "}
                </p>
                <div className="form-group">
                  <label>
                    Name:<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="authorityName"
                    value={formData.authorityName}
                    onChange={handleChange}
                    maxLength={FIELD_MAX_LENGTH}
                    className={`form-input ${
                      !formData.authorityName && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Name"
                  />
                  {fieldErrors.authorityName && (
                    <span className="error-tooltip">
                      {fieldErrors.authorityName}
                    </span>
                  )}
                  {!formData.authorityName && currentStep === 2 && (
                    <span className="error-tooltip">Name is required</span>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Designation:<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    name="authorityTitle"
                    value={formData.authorityTitle}
                    onChange={handleChange}
                    maxLength={FIELD_MAX_LENGTH}
                    className="form-input"
                    placeholder="Designation"
                  />
                  {fieldErrors.authorityTitle && (
                    <span className="error-tooltip">
                      {fieldErrors.authorityTitle}
                    </span>
                  )}
                  {!formData.authorityTitle && currentStep === 2 && (
                    <span className="error-tooltip">Name is required</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Landline:{" "}
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityLandline"
                    type="number"
                    name="authorityLandline"
                    value={formData.authorityLandline}
                    onChange={handleChange}
                    // onBlur={(e) => handleBlur('authorityLandline', e.target.value)}
                    className={`form-input ${
                      !formData.authorityLandline && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Landline number"
                    aria-required="true"
                    aria-describedby={
                      fieldErrors.authorityLandline
                        ? "authorityLandline-error"
                        : undefined
                    }
                  />
                  {!formData.authorityLandline && currentStep === 2 && (
                    <span className="error-tooltip">
                      Authority Landline Number is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Mobile:
                    {/* <span className="text-red" aria-hidden="true"></span> */}
                  </label>
                  <input
                    id="authorityPhone"
                    type="tel"
                    name="authorityPhone"
                    value={formData.authorityPhone}
                    onChange={handleChange}
                    // onBlur={(e) => handleBlur('authorityPhone', e.target.value)}
                    className="form-input"
                    placeholder="Phone number"
                    maxLength={PHONE_MAX_LENGTH}
                    aria-required="true"
                    // aria-describedby={fieldErrors.authorityPhone ? 'authorityPhone-error' : undefined}
                  />
                </div>

                <div className="form-group">
                  <label>
                    Email:<span className="text-red">*</span>
                  </label>
                  <input
                    type="email"
                    name="authorityEmail"
                    value={formData.authorityEmail}
                    onChange={handleChange}
                    className={`form-input ${
                      !formData.authorityEmail && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="E-mail address"
                  />
                  {fieldErrors.authorityEmail && (
                    <span className="error-tooltip">
                      {fieldErrors.authorityEmail}
                    </span>
                  )}
                  {!formData.authorityEmail && currentStep === 2 && (
                    <span className="error-tooltip">Email is required</span>
                  )}
                </div>
              </div>
              <div className="step-section">
                <h4>
                  Contacts (Nodal Officials) <span className="text-red">*</span>
                </h4>
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="copyApplicantData"
                      onChange={handleCopyApplicantToggle}
                      className="form-checkbox"
                    />{" "}
                    Same as applicant
                  </label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">
                    Name:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_name}
                    onChange={handleChange}
                    placeholder="Contact name"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      !formData.contact_name && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    aria-describedby="contact_name-error"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">
                    Phone:
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contact_phone}
                    onChange={handleChange}
                    aria-describedby="contact_phone-error"
                    disabled={copyApplicantData}
                    placeholder="10-digit phone number"
                    className={`form-input ${
                      !formData.contact_phone && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">Email:</label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_email}
                    onChange={handleChange}
                    placeholder="Contact email"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      fieldErrors.contact_email ? "has-error" : ""
                    }`}
                    aria-describedby="contact_email-error"
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Brief write up on company’s profile.</label>
              <p className="note">(within 300 words) </p>
              <textarea
                name="companyProfile"
                value={formData.companyProfile}
                onChange={handleChange}
                className="form-textarea"
                rows={6}
                // maxLength={COMPANY_PROFILE_MAX_LENGTH}
              />
              {fieldErrors.companyProfile && (
                <span className="error-tooltip">
                  {fieldErrors.companyProfile}
                </span>
              )}
            </div>
          </>
        )}

        {currentStep === 3 && (
          <>
            <h3 className="step-title">
              Step 3: Quantitative Information -Part 1
            </h3>
            <table className="quant-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Particulars</th>
                  <th>2024-25</th>
                </tr>
              </thead>
              <tbody>
                {data.slice(0, 9).map((item) => (
                  <tr key={item.num}>
                    <td className="sno-cell">{item.num}</td>
                    <td className="label-cell">{item.title}</td>
                    <td>
                      {/* <input
                        type="text"
                        name={item.key2024}
                        value={formData[item.key2024] || ""}
                        // onChange={e => handleChange(e.target.name, e.target.value)}
                        onChange={(e) => {
    // Allow only digits
    if (/^\d*$/.test(e.target.value)) {
      handleChange(e);
    }
  }}
                        className="form-input"
                        min="0"
                        onKeyDown={(e) => {
                          if (["-", "e", "E"].includes(e.key))
                            e.preventDefault();
                        }}
                      /> */}
                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        type="text" // use text to prevent browser spinners
                        name={item.key2024}
                        value={formData[item.key2024] || ""}
                        onChange={(e) => {
                          let val = e.target.value;

                          // Allow only digits and a single decimal point
                          val = val.replace(/[^0-9.]/g, "");
                          const parts = val.split(".");
                          if (parts.length > 2) {
                            val = parts[0] + "." + parts.slice(1).join("");
                          }

                          handleChange({
                            target: {
                              name: e.target.name,
                              value: val,
                            },
                          });
                        }}
                        onKeyDown={(e) => {
                          // block '-', '+', 'e', 'E', arrow keys
                          if (
                            ["-", "+", "e", "E"].includes(e.key) ||
                            e.key === "ArrowUp" ||
                            e.key === "ArrowDown"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()} // disable mouse scroll increment
                        className="form-input"
                        inputProps={{
                          inputMode: "decimal", // mobile numeric keypad
                          pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
                          min: 0, // maintain minimum value 0
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {currentStep === 4 && (
          <>
            <h3 className="step-title">
              Step 4: Quantitative Information - Part 2
            </h3>
            <table className="quant-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Particulars</th>
                  <th>2024-25</th>
                  <th>2023-24</th>
                </tr>
              </thead>
              <tbody>
                {data.slice(9, 12).map((item) => (
                  <tr key={item.num}>
                    <td className="sno-cell">{item.num}</td>
                    <td className="label-cell">{item.title}</td>
                    <td>
                      {/* <input
                        type="text"
                        name={item.key2024}
                        value={formData[item.key2024] || ""}
                        onChange={(e) => {
    // Allow only digits
    if (/^\d*$/.test(e.target.value)) {
      handleChange(e);
    }
  }}
                        className="form-input"
                        min="0"
                        onKeyDown={(e) => {
                          if (["-", "e", "E"].includes(e.key))
                            e.preventDefault();
                        }}
                      /> */}
                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        type="text" // prevents browser number spinners
                        name={item.key2024}
                        value={formData[item.key2024] || ""}
                        onChange={(e) => {
                          let val = e.target.value;

                          // Allow only digits and one decimal point
                          val = val.replace(/[^0-9.]/g, "");
                          const parts = val.split(".");
                          if (parts.length > 2) {
                            val = parts[0] + "." + parts.slice(1).join("");
                          }

                          handleChange({
                            target: {
                              name: e.target.name,
                              value: val,
                            },
                          });
                        }}
                        onKeyDown={(e) => {
                          // block '-', '+', 'e', 'E', arrow keys
                          if (
                            ["-", "+", "e", "E"].includes(e.key) ||
                            e.key === "ArrowUp" ||
                            e.key === "ArrowDown"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()} // prevent mouse scroll increment
                        className="form-input"
                        inputProps={{
                          inputMode: "decimal", // mobile numeric keypad
                          pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
                          min: 0, // maintain minimum value
                        }}
                      />
                    </td>
                    <td>
                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        type="text" // prevents browser number spinners
                        name={item.key2023}
                        value={formData[item.key2023] || ""}
                        onChange={(e) => {
                          let val = e.target.value;

                          // Allow only digits and one decimal point
                          val = val.replace(/[^0-9.]/g, "");
                          const parts = val.split(".");
                          if (parts.length > 2) {
                            val = parts[0] + "." + parts.slice(1).join("");
                          }

                          handleChange({
                            target: {
                              name: e.target.name,
                              value: val,
                            },
                          });
                        }}
                        onKeyDown={(e) => {
                          // block '-', '+', 'e', 'E', arrow keys
                          if (
                            ["-", "+", "e", "E"].includes(e.key) ||
                            e.key === "ArrowUp" ||
                            e.key === "ArrowDown"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()} // prevent mouse scroll increment
                        className="form-input"
                        inputProps={{
                          inputMode: "decimal", // mobile numeric keypad
                          pattern: "[0-9]*\\.?[0-9]*", // digits + optional decimal
                          min: 0, // maintain minimum value
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <table className="quant-table">
              <thead>
                <tr>
                  <th colSpan="1">12</th>
                  <th colSpan="7">
                    <p className="tablerowq">Upcoming projects</p>
                  </th>
                </tr>
              </thead>
              <thead></thead>

              <thead>
                <tr>
                  <th>S. No</th>
                  <th>Project Name</th>
                  <th>Location</th>
                  <th>Capacity (KT)</th>
                  <th>Project Completion Year</th>
                  <th>Project Current Status</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((i) => (
                  <tr key={i}>
                    <td className="sno-cell">{i}</td>
                    <td>
                      <input
                        type="text"
                        name={`projectName${i}`}
                        value={formData[`projectName${i}`] || ""}
                        onChange={handleChange}
                        className="form-input"
                        maxLength={FIELD_MAX_LENGTH}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name={`location${i}`}
                        value={formData[`location${i}`] || ""}
                        onChange={handleChange}
                        className="form-input"
                        maxLength={FIELD_MAX_LENGTH}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        name={`capacity${i}`}
                        value={formData[`capacity${i}`] || ""}
                        onChange={handleChange}
                        className="form-input"
                        min="0"
                        onKeyDown={(e) => {
                          if (["-", "e", "E"].includes(e.key))
                            e.preventDefault();
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        name={`projectCompletionYear${i}`}
                        value={formData[`projectCompletionYear${i}`] || ""}
                        onChange={handleChange}
                        className="form-input"
                        min="0"
                        onKeyDown={(e) => {
                          if (["-", "e", "E"].includes(e.key))
                            e.preventDefault();
                        }}
                      />
                    </td>
                    <td>
                      {/* <input
                        type="text"
                        name={`projectCurrentStatus${i}`}
                        value={formData[`projectCurrentStatus${i}`] || ""}
                        onChange={handleChange}
                        className="form-input"
                        maxLength={FIELD_MAX_LENGTH}
                      /> */}
                      <textarea
                        name={`projectCurrentStatus${i}`}
                        value={formData[`projectCurrentStatus${i}`] || ""}
                        onChange={(e) => {
                          const { value } = e.target;
                          const words = value.trim().split(/\s+/).filter(Boolean);
 
                          if (words.length > 100) {
                            alert("maximum 100 words allowed.");
                            return;
                          }
 
                          handleChange(e);
                        }}
                        className="form-input resize-none"
                        rows={3}
                      />

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="step-section">
              <div className="form-group">
                <label>Comments</label>
                <textarea
                  name="comment"
                  value={formData.comment}
                  onChange={handleChange}
                  className="form-textarea"
                  // maxLength={COMMENT_MAX_LENGTH}
                  placeholder="Comments ( within 200 words) against input parameter, if any"
                />
                {fieldErrors.comment && (
                  <span className="error-tooltip">{fieldErrors.comment}</span>
                )}
              </div>

              <br />
              <p className="notes">
                <strong>Notes:</strong>
                <br />
                Investments on enhancing hydrogen capacities (other than green
                hydrogen) within refineries for internal consumption should not
                be included in the above.
              </p>
            </div>
          </>
        )}

        {currentStep === 5 && (
          <>
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>

            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Description</th>
                    <th>Upload (only jpg, png, pdf, max 5 MB each)</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key];
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description || ""}
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                            className="form-input"
                            maxLength={FIELD_MAX_LENGTH}
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "file",
                                e.target.files[0],
                                e
                              )
                            }
                            className="form-input mt-4"
                          />
                          {attachment.file && (
                            <p className="file-name">
                              Selected file: {attachment.file.name}
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody> */}
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || {
                      description: "",
                      file: null,
                    };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description}
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                            maxLength={FIELD_MAX_LENGTH}
                            className="form-input"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "file",
                                e.target.files[0],
                                e
                              )
                            }
                            className="form-input mt-4"
                          />
                          {attachment.file && (
                            <p className="file-name">
                              Selected file: {attachment.file.name}
                            </p>
                          )}
                          
                          {attachment.url && !attachment.file && (
                            <p className="file-name">
                              Uploaded file:{" "}
                              <button
                                type="button"
                                onClick={() => viewFile(attachment.url)}
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  color: "#06c",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                View
                              </button>
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="form-group">
              <label>
                Print the completed application form and upload it with the
                signature of the approving authority. Without signature of the
                approving authority, application will not be considered valid.
                <span className="text-red">*</span>
              </label>
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={handlePrint}
                  className="btn btn-outline"
                >
                  Print Preview
                </button>
              </div>
            </div>
            {/* <div className="form-group">
              <label htmlFor="approving_authority_file">
                Upload Document with Approving Authority Signature
                (Director/Board Level)
                <span aria-hidden="true" className="text-red">
                  *
                </span>
                :
              </label>
              <input
                type="file"
                id="approving_authority_file"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm(
                      "Are you sure the form is approved and signed by approving authority?"
                    );
                    if (!confirmed) {
                      // If user clicks "Cancel", clear the input
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${
                  fieldErrors.approving_authority_file ? "has-error" : ""
                }`}
                aria-describedby="approving_authority_file-error"
                required
              />
              {formData.approving_authority_file && (
                <p className="file-name">
                  Selected file: {formData.approving_authority_file.name}
                </p>
              )}
             
               {formData.approvingAuthoritySignatureUrl && !formData.approvingAuthoritySignature && <p className="file-name">Uploaded file: <a href={formData.approvingAuthoritySignatureUrl} target="_blank" rel="noreferrer">View</a></p>}
              {fieldErrors.approving_authority_file && (
                <span
                  className="error-tooltip"
                  id="approving_authority_file-error"
                  role="alert"
                >
                  {fieldErrors.approving_authority_file}
                </span>
              )}
            </div> */}
            <div className="form-group">
              <label htmlFor="approving_authority_file">
                Upload Document with Approving Authority Signature
                (Director/Board Level)
                <span aria-hidden="true" className="text-red">
                  *
                </span>
                :
              </label>
              <input
                type="file"
                id="approving_authority_file"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm(
                      "Are you sure the form is approved and signed by approving authority?"
                    );
                    if (!confirmed) {
                      // If user clicks "Cancel", clear the input
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${
                  fieldErrors.approving_authority_file ? "has-error" : ""
                }`}
                aria-describedby="approving_authority_file-error"
                required
              />
              {formData.approving_authority_file && (
                <p className="file-name">
                  Selected file: {formData.approving_authority_file.name}
                </p>
              )}

              {/* <-- CHANGED: do not expose backend path. Use viewApprovingAuthorityFile to fetch via apiClient and open a blob URL */}
              {formData.approvingAuthoritySignatureUrl &&
                !formData.approvingAuthoritySignature && (
                  <p className="file-name">
                    Uploaded file:{" "}
                    <button
                      type="button"
                      onClick={() =>
                        viewFile(formData.approvingAuthoritySignatureUrl)
                      }
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        color: "#06c",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  </p>
                )}

              {fieldErrors.approving_authority_file && (
                <span
                  className="error-tooltip"
                  id="approving_authority_file-error"
                  role="alert"
                >
                  {fieldErrors.approving_authority_file}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={handleChange}
                  className="form-checkbox"
                />
                I declare that the information submitted is true and complete.
              </label>
            </div>
          </>
        )}
      </div>
    );
  };
  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: "smooth" });
  }, [currentStep]);

  return (
    <div className="sidebar-guideline-container">
      <SidebarGuideline
        isOpen={true}
        sidebarItems={[{ id: "Guideline", label: "Guideline" }]}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        selectedAwardCategory={formData.category}
      />
      <div className="application-form">
        <div className="form-header">
          <h1>{awardTitle}</h1>
          <p>Step {currentStep} of 5</p>
        </div>
        {error && <div className="error">{error}</div>}

        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your Application has been successfully submitted.</p>
            <button onClick={() => navigate("/#Award%20Categories")}>
              Submit Another Application
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {renderStepContent()}

            {currentStep === 1 && (
              <div className="form-navigation-step1">
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                <button
                  type="button"
                  onClick={nextStep}
                  className="btn btn-primary"
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            )}

            {currentStep > 1 && (
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={prevStep}
                  className="btn btn-outline"
                >
                  <ChevronLeft size={16} /> Previous
                </button>
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                {currentStep < 5 && (
                  <button
                    type="button"
                    onClick={nextStep}
                    className="btn btn-primary"
                  >
                    Next <ChevronRight size={16} />
                  </button>
                )}
                {currentStep === 5 && (
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={isSubmited()}
                    onClick={(e) => {
                      if (!formData.declaration) {
                        return alert(
                          "Please accept the declaration before submitting."
                        );
                      }
                      if (!formData.approvingAuthoritySignature) {
                        return alert(
                          "Please upload the approving authority signature file."
                        );
                      }
                      if (!window.confirm("Are you sure you want to submit?")) {
                        e.preventDefault();
                      }
                      alert(
                        "green-hydrogen registration submitted successfully!"
                      );
                      setIsSubmitted(true);

                      handleSubmit(e, "submit");
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationGH;
